export type AddToAllDialogType = "directive" | "nationalLaw" | "doubleLegalBasis" | "deletionPeriod";

export interface DialogTypeState {
    displayOnClick: boolean;
    isDisplayed: boolean;
}

export interface AddToAllDialogState {
    directive: DialogTypeState;
    nationalLaw: DialogTypeState;
    doubleLegalBasis: DialogTypeState;
    deletionPeriod: DialogTypeState;
    selectedEntityId: string;
}

export function createInitialState(): AddToAllDialogState {
    return {
        directive: { displayOnClick: true, isDisplayed: false },
        nationalLaw: { displayOnClick: true, isDisplayed: false },
        doubleLegalBasis: { displayOnClick: true, isDisplayed: false },
        deletionPeriod: { displayOnClick: true, isDisplayed: false },
        selectedEntityId: "",
    };
}
